import { IsNotEmpty, MaxLength } from "class-validator";
import Spec from "constants/Spec";
import { PlanType } from "types/enum/PlanType";

export default class UpdateCompanyGroupReq {
  @IsNotEmpty({
    message: "",
  })
  readonly companyGroupId: number;

  @MaxLength(Spec.maxLength.company.name, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.name,
    },
  })
  @IsNotEmpty({ message: "" })
  name!: string;

  @MaxLength(Spec.maxLength.company.kana, {
    message: "",
    context: {
      constraint1: Spec.maxLength.company.kana,
    },
  })
  @IsNotEmpty({ message: "" })
  kana!: string;

  @IsNotEmpty({ message: "" })
  plan!: PlanType;

  /**
   * 離脱判定の窓（日）。空欄なら既定（90 日）。
   *
   * 型を任意にしてある理由
   *   2026-08-26 …必須にしたら Payment/index.tsx の 2 箇所が落ちた。
   *   あちらは この項目を持たない物を そのまま渡している。
   *   任意にしておけば あちらは送らず、サーバーが「触らない」と読む。
   *   必須にすると あちらが空を送り、設定が消える ── だから任意が正しい。
   *
   * 値を数へ直しているのは この class ではない。
   *   FormModal は Object.assign(new updateType(), {...formData}) で作るので、
   *   コンストラクタは引数なしで呼ばれる。ここに書いた変換は走らない。
   *   実際に数へ直しているのは FormField の FormType.Number
   *   （components/FormField.tsx:212）。
   *
   * 空欄で既定へ戻す道は 通っている（2026-08-29 実測で 確かめ直した）
   *   ⚠️ ここには 2026-08-26 まで「まだ通っていない」と書いてあった。
   *     その字は commit 3056a888 の前の姿で、直した後も 残っていた。
   *     読んだ人が「壊れている」と読む形だったので 直す。
   *
   *   いまの道（三つとも 実物で 確かめた）
   *     欄        …FormType.Number ＋ emptyAsNull: true（CompanyGroup/index.tsx:76）
   *     渡す所    …FormModal.tsx:234 が emptyAsNull を そのまま 渡す
   *     直す所    …FormField.tsx:232 が 立っている欄だけ
   *                 空欄 ⇒ null ／ それ以外 ⇒ Number(value)
   *
   *   ⚠️ 元の式（`value === null || undefined || ""`）は そのまま 残している。
   *     69 か所が 依存しており、0 に意味の在る欄も 在るため。
   *     emptyAsNull を 立てた欄だけ 約束どおりに なる形。
   */
  guestActiveWindowDays?: number | null;

  constructor(arg: any) {
    arg = arg || {};
    this.companyGroupId = arg.companyGroupId;
    this.name = arg.name;
    this.kana = arg.kana;
    this.plan = arg.plan;
    // guestActiveWindowDays はここで触らない。
    //   FormModal が Object.assign で後から入れるので、
    //   ここで既定を入れると 入れた値を上書きしてしまう。
  }
}
